/** Marca do AmaView (mesmo desenho do favicon). */
export function BrandMark(props: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={props.className} aria-hidden>
      <circle cx="32" cy="32" r="30" fill="#0b1220" stroke="#2a3b58" strokeWidth="2" />
      <path d="M8 34c8-10 18-14 26-10s14 2 22-6" fill="none" stroke="#34d399" strokeWidth="5" strokeLinecap="round" />
      <path d="M12 44c9-6 17-7 24-4s12 2 18-3" fill="none" stroke="#38bdf8" strokeWidth="4" strokeLinecap="round" />
      <circle cx="44" cy="22" r="5" fill="#f97316" />
    </svg>
  );
}

export function Brand(props: { compact?: boolean }) {
  return (
    <div className="flex min-w-0 items-center gap-2.5">
      <BrandMark className="size-8 shrink-0" />
      <div className="min-w-0 leading-tight">
        <div className="text-[17px] font-semibold tracking-tight text-white">AmaView</div>
        {!props.compact && <div className="truncate text-[11px] text-ink-300">Amazônia em dados abertos</div>}
      </div>
    </div>
  );
}
